import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2ced7a48")

_pushScopeId("data-v-2ced7a48")
const _hoisted_1 = { class: "col-12 col-md-6 moment" }
const _hoisted_2 = { class: "moment-elm skeleton-moment" }
const _hoisted_3 = { class: "loading-video" }
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  class: "loading-svg-icon loading-svg-icon-small shaka-big-play",
  viewBox: "0 0 61 61",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("rect", {
    width: "61",
    height: "61",
    rx: "12",
    fill: "#ccc"
  }),
  /*#__PURE__*/_createVNode("path", {
    fill: "#fff",
    d: "M22 21.5763C22 19.5799 24.1634 18.3445 25.8688 19.367L40.752 28.2906C42.416 29.2884 42.416 31.7115 40.752 32.7092L25.8688 41.633C24.1635 42.6555 22 41.4201 22 39.4237L22 21.5763Z"
  })
], -1)
const _hoisted_5 = { class: "loading-message" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "skeleton-title skeleton" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "skeleton-paragraph skeleton" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "skeleton-paragraph skeleton" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.loadingmsg), 1)
      ]),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8
    ])
  ]))
})